module.exports = __webpack_public_path__ + "img/no_wifi.dcc677bd.png";